function filterListMobileScroll() {
  const filters = document.querySelectorAll('[data-tag-filter]');

  if (!filters) { return; }

  function calcWidth() {
    filters.forEach(filter => {
      const filterList = filter.querySelector('[data-tag-filter-list]');
      const filterListItems = filter.querySelectorAll('[data-tag-filter-list] > li');

      let filterWidth = 0;
      filterListItems.forEach(filterListItem => {
        const itemStyle = filterListItem.currentStyle || window.getComputedStyle(filterListItem);
        filterWidth += filterListItem.offsetWidth + parseFloat(itemStyle.marginRight);
      });

      filterList.style.width = `${filterWidth + 24}px`;
    });
  }

  function resetWidth() {
    filters.forEach(filter => {
      const filterList = filter.querySelector('[data-tag-filter-list]');
      filterList.removeAttribute('style');
    });
  }

  const breakpoint = window.matchMedia('(max-width: 750px)');

  breakpoint.addListener(breakpointCheck);

  function breakpointCheck() {
    if (breakpoint.matches === true) {
      setTimeout(() => {
        calcWidth();
      }, 500);
    } else {
      resetWidth();
    }
  }

  breakpointCheck();
}

document.addEventListener('DOMContentLoaded', () => {
  filterListMobileScroll();
});

document.addEventListener('shopify:section:load', () => {
  filterListMobileScroll();
});
